export const PUBLISH_DISABLED_HINT_MESSAGES = {
  NO_DATA_CHANGED: 'No data has changed',
  PLAYER_PARAMS_INVALID: 'There is a validation error on player parameters',
  GAME_PARAMS_INVALID: 'There is a validation error on game parameters',
  INFER_CHANGES_PENDING: 'Publish is disabled while infer changes are pending',
};

export const getPublishDisabledHintMessage = ({
  hasDataChanged,
  isPlayerParamsValid = true,
  isGameParamsValid = true,
  includePlayerValidation = true,
  includeGameValidation = true,
  isInferBlocking = false,
} = {}) => {
  if (isInferBlocking) {
    return PUBLISH_DISABLED_HINT_MESSAGES.INFER_CHANGES_PENDING;
  }
  if (!hasDataChanged) {
    return PUBLISH_DISABLED_HINT_MESSAGES.NO_DATA_CHANGED;
  }
  if (includePlayerValidation && !isPlayerParamsValid) {
    return PUBLISH_DISABLED_HINT_MESSAGES.PLAYER_PARAMS_INVALID;
  }
  if (includeGameValidation && !isGameParamsValid) {
    return PUBLISH_DISABLED_HINT_MESSAGES.GAME_PARAMS_INVALID;
  }
  return null;
};
